import React from 'react';
import { Project } from '../../../types';

interface Props { project: Project; }

export default function LoopTab({ project }: Props) {
  if (!project.dagrun_pm_loopworkspaceid) {
    return (
      <div style={{ padding: '24px 32px' }}>
        <div className="card" style={{ padding: 48, textAlign: 'center', maxWidth: 560, margin: '40px auto' }}>
          <div className="eyebrow">LOOP WORKSPACE</div>
          <h3 style={{
            fontFamily: 'var(--font-ui)', fontWeight: 600, fontSize: 16,
            color: 'var(--ink-2)', marginTop: 12,
          }}>
            Loop workspace not connected
          </h3>
          <p style={{ fontWeight: 300, fontSize: 14, color: 'var(--ink-3)', marginTop: 8 }}>
            Connect a Microsoft Loop workspace to share live components with your team.
          </p>
          <button className="btn-primary" style={{ marginTop: 16 }} onClick={() => alert('Loop provisioning requires tenant admin configuration in Phase 6.')}>
            Connect Loop
          </button>
        </div>
      </div>
    );
  }
  return (
    <iframe
      title="Loop"
      src={project.dagrun_pm_loopworkspaceid}
      style={{ width: '100%', height: '100%', border: 'none' }}
    />
  );
}
